export const SIGNED_STATUS = {
  SIGNED: 'signed',
  NOT_SIGNED: 'notSigned',
  PARTIALLY_SIGNED: 'partiallySigned',
} as const

// `notApplicable` documents never need a reason: they are filtered out of the backoffice list.
export const EMPLOYEE_CENTER_HIDDEN_REASON = {
  FLAG_OFF: 'flagOff' as const,
  MISSING_TRANSLATION: 'missingTranslation' as const,
  NO_APPROVED_VERSION: 'noApprovedVersion' as const,
} as const

export type IEmployeeCenterHiddenReason =
  (typeof EMPLOYEE_CENTER_HIDDEN_REASON)[keyof typeof EMPLOYEE_CENTER_HIDDEN_REASON]

// Per-policy signature state for one employee, derived by comparing the version they
// signed against the latest approved version. `SIGNED_STATUS` above is the employee-level
// aggregate across all their policies.
export const POLICY_SIGNATURE_STATUS = {
  UNSIGNED: 'unsigned' as const,
  SIGNED: 'signed' as const,
  OUTDATED: 'outdated' as const,
} as const

export type IPolicySignatureStatus = (typeof POLICY_SIGNATURE_STATUS)[keyof typeof POLICY_SIGNATURE_STATUS]

// Cell values for the signature CSV export. `NOT_APPLICABLE` covers a policy with no approved
// version in the editor at all, where "is the signature current" has no answer to give.
export const POLICY_SIGNATURE_EXPORT = {
  YES: 'Yes' as const,
  NO: 'No' as const,
  NOT_APPLICABLE: 'N/A' as const,
} as const

export type IPolicySignatureExportCell = (typeof POLICY_SIGNATURE_EXPORT)[keyof typeof POLICY_SIGNATURE_EXPORT]
